import { render } from "./excellentcourse.vue?vue&type=template&id=bebf1cb6&scoped=true&ts=true"
import script from "./excellentcourse.vue?vue&type=script&lang=ts"
export * from "./excellentcourse.vue?vue&type=script&lang=ts"

import "./excellentcourse.vue?vue&type=style&index=0&id=bebf1cb6&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bebf1cb6"]])

export default __exports__